
require('../assets/styles/jquery-ui_blue-theme.css');
require("jquery-ui/dist/themes/base/jquery-ui.min.css");
require("jquery-ui/dist/jquery-ui.min.js");

// NOTE: PA expects this to be ready/avail on the page so CDN can't be used _here_
// but could be through a script tag directly on the page

// NB: Using ClientSideWebModules to load the /vendors/jquery-ui.css stylesheet
// to retain the CSS load order which impacts precedence as .ui-front is set in
// multiple CSS files with identical specificity

// [
//   "/vendors/jquery-ui.css"
// ].forEach(injectResource);